export default __webpack_public_path__ + "static/media/login.b031f795.png";